import React, {useId} from 'react';
import {Tooltip, OverlayTrigger} from 'react-bootstrap';

export default function HelpTooltip (props) {
  const { children } = props;
  const id = useId();
  return (
    <OverlayTrigger placement="left" overlay={(
      <Tooltip id={id}>
        {children}
      </Tooltip>
    )}
    >
      <span><i className="icon mdi mdi-help"></i></span>
    </OverlayTrigger>
  );
}
